import type { ReactNode } from 'react';

import { CommendaAgentMentionHelper } from '../commenda-agent-mention-helper';
import CommendaAgentMentionPill from './CommendaAgentMentionPill';

interface ChatMessageLinkProps {
  href?: string;
  children?: ReactNode;
}

const ChatMessageLink = ({ href, children }: ChatMessageLinkProps) =>
  href === CommendaAgentMentionHelper.MARKDOWN_HREF ? (
    <CommendaAgentMentionPill />
  ) : (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-text-info hover:underline"
    >
      {children}
    </a>
  );

export default ChatMessageLink;
